import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapState, mapGetters } from 'vuex';
import AppLoader from 'components/app-loader/AppLoader';
import { loaderPrefs } from 'components/app-loader/loaderPrefs';
export default {
  name: 'App',
  components: {
    AppLoader: AppLoader
  },
  data: function data() {
    return {
      langs: [{
        label: 'NL',
        value: 'nl-nl'
      }, {
        label: 'EN',
        value: 'en-us'
      }, {
        label: 'DE',
        value: 'de-de'
      }]
    };
  },
  mounted: function mounted() {
    // this.$q.loading.show({})
    if (this.$q.platform.is.cordova) {
      // document.addEventListener('deviceready', this.onDeviceReady, false)
      // document.addEventListener('offline', this.onOffline, false)
      // document.addEventListener('online', this.onOnline, false)
      // document.addEventListener('pause', this.onPause, false)
      document.addEventListener('resume', this.onResume, false); // document.addEventListener('menubutton', this.onMenuKeyDown, false)
      // document.addEventListener('backbutton', this.onBackKeyDown, false)
    }

    var locale = this.$q.localStorage.getItem('locale');

    if (this.user) {
      if (this.user.locale) {
        locale = this.user.locale; // this.$q.localStorage.set('locale', this.$i18n.locale)
      } else {
        // eslint-disable-next-line no-restricted-syntax
        this.$meteor.call('user.setLocale', locale, function (err) {
          if (err) {} else {}
        });
      }
    } // no language chosen yet (a fresh browser, an account without one): English, the boot's own (null broke every
    // toLocaleString(this.$i18n.locale), e.g. UiTableMore's count)


    this.$i18n.locale = locale || this.$i18n.fallbackLocale; // if (locale) {
    //     this.$i18n.locale = locale
    //
    // }

    /* console.log('qeury', this.$route.query)
    console.log('lang MVD', this.$route.query.lang)
    let locale = this.$q.localStorage.getItem('locale')
    console.log('WW' + locale)
    if (locale) {
        this.$i18n.locale = locale
    } else {
        this.$i18n.locale = {
            label: 'NL',
            value: 'nl-nl'
        }
    } */
    // throw new Error('Sentry Error MVD')
  },
  computed: _objectSpread({}, mapState(['user', 'appStarted']), {}, mapGetters(['appReady'])),
  watch: {
    appReady: {
      immediate: true,
      handler: function handler(ready) {
        if (ready) this.start(false);
      }
    }
  },
  methods: {
    // by hand ("open anyway"), or when the data is in, unless the loader is held to be looked at (dev)
    start: function start(byHand) {
      if (this.appStarted || !byHand && (loaderPrefs.hold || loaderPrefs.pause)) return;
      this.$store.commit('APP_STARTED');
    },
    onResume: function onResume() {
      this.$meteor.reconnect();
    }
  }
};